module.exports = __webpack_public_path__ + "static/img/11.135a298.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/11.png
// module id = KPHb
// module chunks = 0